import { AfterContentInit, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Globals } from './wings-mobile/shared/globals/globals';
import { GlobalsService } from './wings-mobile/shared/globals/globals.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [RouterOutlet]
})
export class AppComponent implements AfterContentInit {

	constructor(public globals: Globals) {
		this.globals = globals;
	}

	ngAfterContentInit(): void {
		this.validateUserWarehouse();
	}

	validateUserWarehouse() {
		let user: String = localStorage.getItem('user');

		if ((this.globals.user == null || this.globals.user.warehouse == null) && user != null) {
			GlobalsService.get('changeUser').emit(JSON.parse(user.toString()));
		}
	}
}

